import * as Avatars from './avatars';
import * as Checkout from './checkout';
import * as General from './general';
import * as HelpCenter from './helpcenter';
import * as Logos from './logos';
import * as Payments from './payments';
import * as Tracking from './tracking';
import * as Warranties from './warranties';

const IconConfigs = {
  ...Checkout,
  ...Logos,
  ...Payments,
  ...Warranties,
  ...Avatars,
  ...HelpCenter,
  ...General,
  ...Tracking,
};

type IconName = keyof typeof IconConfigs;

type GetIconProps = {
  name: IconName;
  themeName: string;
  hostname?: string;
};

const getIcon = ({ name, themeName, hostname }: GetIconProps) => {
  if (name in IconConfigs && IconConfigs[name][themeName]) {
    const { alt = 'Ícone', ...iconConfig } = IconConfigs[name];
    const { src, height, width } = iconConfig[themeName];
    const finalSrc = hostname && !/^https?:\/\//.test(src) ? `${hostname}${src}` : src;

    return {
      alt,
      src: finalSrc,
      height,
      width,
    };
  }

  return null;
};

export default getIcon;
export type { IconName };
